import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section aria-label="LACROSSE READY 360 in numbers" className="w-full bg-pine px-5 py-12 md:py-14" data-id="element-216" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-content grid-cols-2 gap-y-9 text-center md:grid-cols-4 md:gap-8" data-id="element-217" data-mp="1oac57efi2d1c">
        {stats.map(({
        value,
        label
      }, index) => <div key={label} className={`flex flex-col items-center justify-center px-2 ${index > 0 ? 'md:border-l md:border-white/15' : ''}`} data-id="element-218" data-mp="1ecz7bq19piax" data-mpi={index}>
            <span className="font-display text-4xl font-extrabold leading-none tracking-tight text-amber md:text-5xl" data-id="element-219" data-mp="15ke1tbmnd841">
              {value}
            </span>
            <span className="mt-2.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-white md:text-xs" data-id="element-220" data-mp="10jq0nx4pfaw3">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}